import axios from "axios";
import React, { useState, useEffect } from "react";
import {
  Button,
  Form,
  Input,
  Table,
  Space,
  Spin,
  Modal,
  Row,
  Col,
  Tooltip,
} from "antd";
import { useNavigate } from "react-router-dom";
import { FiEdit } from "react-icons/fi";
import { MdAddCircleOutline } from "react-icons/md";
import { AiOutlineDelete } from "react-icons/ai";
import { toast } from "react-toastify";
import conf from "../config";
import Cookies from "js-cookie";

const Departments = ({ setIslogin }) => {
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingData, setEditingData] = useState(null);

  const [modalForm] = Form.useForm();

  // ================= GET DATA =================
  const getDepartments = async () => {
    try {
      setLoading(true);
      const token = Cookies.get("token");

      const res = await axios.get(`${conf.baseurl}/departments`, {
        headers: { Authorization: token },
      });

      setData(res.data || []);
      setLoading(false);
    } catch (error) {
      setLoading(false);

      if (error.response?.status === 401) {
        toast.error("Session expired");
        Cookies.remove("isLoggedIn");
        setIslogin(false);
        navigate("/");
      } else {
        console.log(error.message);
      }
    }
  };

  useEffect(() => {
    getDepartments();
  }, []);

  // ================= ADD =================
  const handleAdd = () => {
    setEditingData(null);
    modalForm.resetFields();
    setIsModalOpen(true);
  };

  // ================= EDIT =================
  const handleEdit = (record) => {
    setEditingData(record);
    modalForm.setFieldsValue({
      name: record.name,
    });
    setIsModalOpen(true);
  };

  // ================= SAVE =================
  const handleSave = async () => {
    try {
      const values = await modalForm.validateFields();
      const token = Cookies.get("token");

      let res;

      if (editingData) {
        // UPDATE
        res = await axios.put(
          `${conf.baseurl}/departments/${editingData.id}`,
          values,
          { headers: { Authorization: token } }
        );
      } else {
        // ADD
        res = await axios.post(
          `${conf.baseurl}/departments`,
          values,
          { headers: { Authorization: token } }
        );
      }

      // ✅ HANDLE DUPLICATE / FAIL RESPONSE
      if (res.data.status === "F") {
        toast.error(res.data.message);
        return;
      }

      toast.success(res.data.message || "Success");

      setIsModalOpen(false);
      getDepartments();

    } catch (error) {
      if (error.response?.status === 401) {
        toast.error("Session expired");
        Cookies.remove("isLoggedIn");
        setIslogin(false);
        navigate("/");
      } else {
        console.log(error.message);
      }
    }
  };

  // ================= DELETE =================
  const deleteDepartment = async () => {
    try {
      const token = Cookies.get("token");

      const res = await axios.delete(
        `${conf.baseurl}/departments/${deleteId}`,
        {
          headers: { Authorization: token },
        }
      );

      toast.success(res.data.message || "Department deleted");

      setShowDeleteModal(false);
      getDepartments();

    } catch (error) {
      if (error.response?.status === 401) {
        toast.error("Session expired");
        Cookies.remove("isLoggedIn");
        setIslogin(false);
        navigate("/");
      }
    }
  };

  // ================= TABLE =================
  const columns = [
    {
      title: "Department Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space>
          <Tooltip title="Edit Department" color="green">
            <Button type="primary" onClick={() => handleEdit(record)}>
              <FiEdit />
            </Button>
          </Tooltip>

          <Tooltip title="Delete Department" color="red">
            <Button
              type="primary"
              onClick={() => {
                setDeleteId(record.id);
                setShowDeleteModal(true);
              }}
            >
              <AiOutlineDelete color="red" />
            </Button>
          </Tooltip>
        </Space>
      ),
    },
  ];

  return (
    <div className="container">
      <Spin spinning={loading}>
        <div className="formWrapper">

          {/* ===== SAME LAYOUT (Search removed, spacing same) ===== */}
          <Row style={{ display: "flex", justifyContent: "flex-end" }}>
            {/* <Col span={10}></Col> */}

           <Button
                type="primary"
                onClick={handleAdd}
                style={{
                    // marginLeft:10,
                    display: "flex",
                    alignItems: "center",
                    gap: "6px",
                    borderRadius: "6px",
             }}
            icon={<MdAddCircleOutline size={18} />}
           >
                Add Department
            </Button>

          </Row>

          {/* ===== TABLE ===== */}
          <Table
            columns={columns}
            dataSource={data}
            rowKey="id"
            style={{ marginTop: 20 }}
            pagination={false}
            className="grid-table"
          />

          {/* ===== ADD / EDIT MODAL ===== */}
          <Modal
            title={editingData ? "Edit Department" : "Add Department"}
            open={isModalOpen}
            onOk={handleSave}
            onCancel={() => setIsModalOpen(false)}
          >
            <Form form={modalForm} layout="vertical">
              <Form.Item
                label="Department Name"
                name="name"
                rules={[
                  { required: true, message: "Please enter department name" },
                ]}
              >
                <Input placeholder="Enter department name" />
              </Form.Item>
            </Form>
          </Modal>

          {/* ===== DELETE MODAL ===== */}
          <Modal
            open={showDeleteModal}
            onOk={deleteDepartment}
            onCancel={() => setShowDeleteModal(false)}
          >
            <p>Are you sure you want to delete this department?</p>
          </Modal>

        </div>
      </Spin>
    </div>
  );
};

export default Departments;
